import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNA: CultureInfo = {
  name: 'en-NA',
  displayName: 'English (Namibia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NA',
  parent: CultureInfoEn
};
